import { Action } from '@ngrx/store';
import { Reason } from '../_models/reason.model';
import { QueryParamsModel } from '../../_base/crud';

export enum ReasonActionTypes {
  ReasonOnServerDeleted = '[Reasons] Reason On Server Deleted',
  ReasonDeleted = '[Reasons] Reason Deleted',
  ReasonsPageRequested = '[Reasons] Reasons Page Requested',
  ReasonsPageLoaded = '[Reasons] Reasons Page Loaded',
  ReasonsPageCancelled = '[Reasons] Reasons Page Cancelled',
  ReasonsPageToggleLoading = '[Reasons] Reasons Page Toggle Loading',
  ReasonsActionToggleLoading = '[Reasons] Reasons Action Toggle Loading',
  ThrowReasonError = '[Reasons] Throw Error',
  FireReasonSuccess = '[Reasons] Fire Success',
}

export class ThrowReasonError implements Action {
  readonly type = ReasonActionTypes.ThrowReasonError;
  constructor(public payload: { error: any }) {}
}

export class FireReasonSuccess implements Action {
  readonly type = ReasonActionTypes.FireReasonSuccess;
  constructor(public payload: { action_type: string }) {}
}

export class ReasonOnServerDeleted implements Action {
  readonly type = ReasonActionTypes.ReasonOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class ReasonDeleted implements Action {
  readonly type = ReasonActionTypes.ReasonDeleted;
  constructor(public payload: { id: number }) {}
}

export class ReasonsPageRequested implements Action {
  readonly type = ReasonActionTypes.ReasonsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class ReasonsPageLoaded implements Action {
  readonly type = ReasonActionTypes.ReasonsPageLoaded;
  constructor(public payload: { reasons: Reason[]; totalCount: number; page: QueryParamsModel }) {}
}

export class ReasonsPageCancelled implements Action {
  readonly type = ReasonActionTypes.ReasonsPageCancelled;
}

export class ReasonsPageToggleLoading implements Action {
  readonly type = ReasonActionTypes.ReasonsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ReasonsActionToggleLoading implements Action {
  readonly type = ReasonActionTypes.ReasonsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export type ReasonActions =
  | ReasonDeleted
  | ReasonOnServerDeleted
  | ReasonsPageLoaded
  | ReasonsPageCancelled
  | ReasonsPageToggleLoading
  | ReasonsPageRequested
  | ThrowReasonError
  | FireReasonSuccess
  | ReasonsActionToggleLoading;
